<template>
  <div>
    <div class="carousel row d-none d-lg-flex">
      <div class="row w-100 justify-content-center">
        <div 
          v-for="(card, index) in cards" 
          :key="index"
          :class="[index === 2 ? 'col-12 col-md-4' : 'col-12 col-md-2']"
          :style="getCardStyle(index)"
        >
        <transition name="fade-move" mode="out-in">
          <div class="card rounded-4 overflow-hidden w-100"  :class="[index === 2 ? 'card--center' : '']" :style="`background-image: url(${index === 2 ? card.image2 : card.image1})`">
            <h6 class="slider_card_title">{{ card.title }}</h6>
            <div v-if="index === 2" class="slider_card_subtitle" v-html="card.subtitle"></div>
          </div>
        </transition>
        </div>
      </div>
    </div>

    <div class="row gy-4 d-none d-sm-flex d-lg-none">
      <div class="col-6" v-for="(card, index) in mobcards" :key="index">
        <div class="card rounded-4 overflow-hidden w-100 card--center mobcard" :style="`background-image: url(${card.image2})`">
          <h6 class="slider_card_title">{{ card.title }}</h6>
          <div class="slider_card_subtitle" v-html="card.subtitle"></div>
        </div>
      </div>
    </div>

    <div class="row gy-4 d-flex d-sm-none">
      <div class="col-12" v-for="(card, index) in mobcards" :key="index">
        <div class="card rounded-4 overflow-hidden w-100 card--center mobcard" :style="`background-image: url(${card.mobimage})`">
          <h6 class="slider_card_title">{{ card.title }}</h6>
          <div class="slider_card_subtitle" v-html="card.subtitle"></div>
        </div>
      </div>
    </div>
</div>
</template>
  
<script>
export default {
  name: 'StaticCarousel',
  data() {
    return {
      cards: [
        { image1: '/static/main/slider/preview/world-preview.png', image2: '/static/main/slider/world-bg.png', mobimage: '/static/main/slider/mob/mezdynarodniy_perevod.png', title: 'Международные переводы', subtitle: 'Быстрые переводы на карты и платежные системы' },
        { image1: '/static/main/slider/preview/cards-preview.png', image2: '/static/main/slider/cards-bg.png', mobimage: '/static/main/slider/mob/virtyalcard.png', title: 'Виртуальные карты', subtitle: 'Выпускайте карты и оплачивай покупки офлайн и онлайн по всему миру!' },
        { image1: '/static/main/slider/preview/stable-preview.png', image2: '/static/main/slider/stable-bg.png', mobimage: '/static/main/slider/mob/stablecoin.png', title: 'Стейблкоины', subtitle: 'Покупка, продажа и конвертация стейблкоинов' },
        { image1: '/static/main/slider/preview/crypto-preview.png', image2: '/static/main/slider/crypto-bg.png', mobimage: '/static/main/slider/mob/crypto.png', title: 'Криптовалюты', subtitle: '<span>Хранение и стейкинг криптовалют.<span/><br/><span>Конвертация по лучшим курсам на рынке<span/>' },
        { image1: '/static/main/slider/preview/urist-preview.png', image2: '/static/main/slider/urist-bg.png', mobimage: '/static/main/slider/mob/urlica.png', title: 'Платежи для юр. лиц', subtitle: '<span>Решения для экспорта и импорта<span/><br/><span>Работа с юр. лицами в РФ и зарубежом<span/>' },
      ],
      mobcards: [
        { image1: '/static/main/slider/preview/world-preview.png', image2: '/static/main/slider/world-bg.png', mobimage: '/static/main/slider/mob/mezdynarodniy_perevod.png', title: 'Международные переводы', subtitle: 'Быстрые переводы на карты и платежные системы' },
        { image1: '/static/main/slider/preview/cards-preview.png', image2: '/static/main/slider/cards-bg.png', mobimage: '/static/main/slider/mob/virtyalcard.png', title: 'Виртуальные карты', subtitle: 'Выпускайте карты и оплачивай покупки офлайн и онлайн по всему миру!' },
        { image1: '/static/main/slider/preview/stable-preview.png', image2: '/static/main/slider/stable-bg.png', mobimage: '/static/main/slider/mob/stablecoin.png', title: 'Стейблкоины', subtitle: 'Покупка, продажа и конвертация стейблкоинов' },
        { image1: '/static/main/slider/preview/crypto-preview.png', image2: '/static/main/slider/crypto-bg.png', mobimage: '/static/main/slider/mob/crypto.png', title: 'Криптовалюты', subtitle: '<span>Хранение и стейкинг криптовалют.<span/><br/><span>Конвертация по лучшим курсам на рынке<span/>' },
        { image1: '/static/main/slider/preview/urist-preview.png', image2: '/static/main/slider/urist-bg.png', mobimage: '/static/main/slider/mob/urlica.png', title: 'Платежи для юр. лиц', subtitle: '<span>Решения для экспорта и импорта<span/><br/><span>Работа с юр. лицами в РФ и зарубежом<span/>' },
      ],
      timer: null,
    };
  },
  mounted() {
    this.timer = setInterval(this.shiftCards, 3000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
  shiftCards() {
    const first = this.cards.shift();
    this.cards.push(first);
  },
  getCardStyle(index) {
    switch (index) {
      case 0:
        return { transform: 'translateY(0px)' };
      case 1:
        return { transform: 'translateY(-70px)' };
      case 2:
        return { transform: 'translateY(-100px)' };
      case 3:
        return { transform: 'translateY(-70px)' };
      case 4:
        return { transform: 'translateY(0px)' };
      default:
        return {};
    }
  }
}
};
</script>
  
  <style scoped>
  .carousel {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .card {
    border: none;
    background-color: rgba(53, 99, 79, .9);
    backdrop-filter: blur(23px);
    height: 328px;
    padding: 30px 15px;
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: auto;
  }

  .slider_card_title {
    font-weight: 600;
    font-size: 17px;
    margin-bottom: 10px;
  }
  
  .card.card--center {
    padding: 30px 34px;
    background-color: transparent;
  }

  .card.card--center.mobcard {
    background-size: 100% 100%;
  }
  
  .fade-move-enter-active {
    transition: opacity 0.8s ease 0.1s; /* 0.1 секунды задержка появления */
  }
  
  .fade-move-leave-active {
    transition: opacity 0.8s ease;
  }
  
  .fade-move-enter-from {
    opacity: 0;
  }
  .fade-move-enter-to {
    opacity: 1;
  }
  .fade-move-leave-from {
    opacity: 1;
  }
  .fade-move-leave-to {
    opacity: 0;
  }



  @media (min-width:576px) and (max-width: 1024px) {
    .card.card--center.mobcard {
      background-color: rgba(53, 99, 79, .9);
    }
    .card h6 {
      font-size: 14px;
    }
    .card .slider_card_subtitle {
      font-size: 12px;
    }
  }

  @media (max-width:576px) {
    .card .slider_card_subtitle {
      font-size: 14px;
    }
    .card.card--center.mobcard {
      padding: 30px 19px;
      background-color: rgba(53, 99, 79, .1);
    }
  }

  @media (max-width: 320px) {
    .card.card--center.mobcard {
      background-size: auto;
    }
  }

  
  </style>
  